import styled from '@emotion/styled';
import { Box } from '@opendoor/bricks-next';

import { generatePresetPictureSet } from 'components/shared/performance/pictures';

import { HERO_IMAGE_DESKTOP_PROPS, HERO_IMAGE_MOBILE_PROPS } from './heroConstants';

const HeroImageContainer = styled(Box)({
  position: 'relative',
  width: '100%',
  objectFit: 'cover',
  borderRadius: '540px 540px 0px 0px',
  aspectRatio: '4 / 5',
  overflow: 'hidden',
  '@media screen and (min-width: 768px)': {
    borderRadius: '540px 540px 36px 36px',
  },
});

interface HeroImagesProps {
  imageDesktopUrl?: string;
  imageMobileUrl?: string;
  lowBandwidth?: boolean;
}

export const HeroImages = ({ imageDesktopUrl, imageMobileUrl, lowBandwidth }: HeroImagesProps) => {
  return (
    <>
      <Box display="none" $largerThanMD={{ display: 'block' }}>
        {imageDesktopUrl && (
          <HeroImageContainer>
            {generatePresetPictureSet({
              ...HERO_IMAGE_DESKTOP_PROPS,
              photoUrl: imageDesktopUrl,
              ...(lowBandwidth ? { quality: 50 } : {}),
            })}
          </HeroImageContainer>
        )}
      </Box>
      <Box display="block" $largerThanMD={{ display: 'none' }}>
        {imageMobileUrl && (
          <HeroImageContainer>
            {generatePresetPictureSet({
              ...HERO_IMAGE_MOBILE_PROPS,
              photoUrl: imageMobileUrl,
              ...(lowBandwidth ? { quality: 50 } : {}),
            })}
          </HeroImageContainer>
        )}
      </Box>
    </>
  );
};
